import { useState } from "react";
import { ethers } from "ethers";
import { ADDRESSES, ABIS } from "../utils/contracts";
import signatures from "../data/signatures.json"; // Ensure this file exists!

export default function FakeMeebits() {
  const [inputTokenId, setInputTokenId] = useState("");

  const mintMeebit = async () => {
    // 1. Find Signature
    const sigData = signatures.find(s => s.tokenId.toString() === inputTokenId);
    
    if (!sigData) {
      alert("No signature found in your JSON for this Token ID.");
      return;
    }

    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      
      // 2. Check if already minted
      const nftContract = new ethers.Contract(ADDRESSES.MEEBITS, ABIS.MEEBITS, provider);
      try {
          const owner = await nftContract.ownerOf(inputTokenId);
          if(owner !== ethers.ZeroAddress) {
              alert("Token already minted!");
              return;
          }
      } catch(e) {
          // ownerOf reverts if not minted, which is good for us
      }

      // 3. Mint using Claimer
      const claimerContract = new ethers.Contract(ADDRESSES.MEEBITS_CLAIMER, ABIS.MEEBITS_CLAIMER, signer);
      
      const tx = await claimerContract.claimAToken(inputTokenId, sigData.signature);
      await tx.wait();
      alert("Meebit Minted Successfully!");
      
    } catch (err) {
      console.error(err);
      alert("Mint failed. See console.");
    }
  };

  return (
    <div>
      <h1>Fake Meebits Claimer</h1>
      <p>Enter a Token ID to mint (must have valid signature in src/data/signatures.json)</p>
      
      <input 
        type="number" 
        value={inputTokenId} 
        onChange={(e) => setInputTokenId(e.target.value)} 
        placeholder="Token ID"
      />
      
      <button onClick={mintMeebit}>Mint with Signature</button>
    </div>
  );
}